<template>
    <div>
        <b-tabs v-model="activeTab">
            
            <b-tab-item label="Carousel">
                <CarouselForm
                :slideList="slideList"
                :slideCreate="slideCreate"
                :slideDetail="slideDetail"
                :details="details"/>
            </b-tab-item>

            <b-tab-item :disabled="!isFullSiteBool" label="Home">
                <Home
                :customHero="customHero"
                :basicHero="basicHero"
                />
            </b-tab-item>

            

            <b-tab-item :disabled="!isFullSiteBool" label="Proveedores">
                <SupplierForm
                :supplierList="supplierList"
                :supplierDetail="supplierDetail"
                :supplierCreate="supplierCreate"
                :supplierSectionDetail="supplierSectionDetail"/>
            </b-tab-item>

            <b-tab-item :disabled="!isFullSiteBool" label="Use cases">
                <CaseForm
                :caseList="caseList"
                :caseCreate="caseCreate"
                :caseDetail="caseDetail"
                :caseSection="caseSection"/>
            </b-tab-item>

            <b-tab-item :disabled="!isFullSiteBool" label="Banners">
                <Banners
                :bannerList="bannerList"
                :bannerCreate="bannerCreate"
                :bannerDetail="bannerDetail"
                />
            </b-tab-item>

        </b-tabs>
    </div>
</template>

<script>
import CarouselForm from "./components/CarouselForm.vue"
import SupplierForm from "./components/SupplierForm.vue"
import CaseForm from "./components/CaseForm.vue"
import Home from "./components/Home.vue"
import Banners from "./components/Banners.vue"
export default {
    components:{
        CarouselForm,
        SupplierForm,
        CaseForm,
        Home,
        Banners
    },
    name:"Cms",
    props:{
        slideList:{
            type:String,
            default:""
        },
        slideDetail:{
            type:String,
            default:""
        },
        slideCreate:{
            type:String,
            default:""
        },
        supplierList:{
            type:String,
            default:""
        },
        supplierCreate:{
            type:String,
            default:""
        },
        supplierDetail:{
            type:String,
            default:""
        },
        supplierSectionDetail:{
            type:String,
            default:""
        },
        caseSection:{
            type:String,
            default:""
        },
        caseDetail:{
            type:String,
            default:""
        },
        caseList:{
            type:String,
            default:""
        },
        caseCreate:{
            type:String,
            default:""
        },
        details:{
            type:String,
            default:""
        },
        basicHero:{
            type:String,
            default:""
        },
        customHero:{
            type:String,
            default:""
        },
        bannerCreate:{
            type:String,
            default:""
        },
        bannerList:{
            type:String,
            default:""
        },
        bannerDetail:{
            type:String,
            default:""
        },
        isFullSite:{
            type:String,
            default:""
        }
    },
    computed:{
        isFullSiteBool(){
            return this.isFullSite == 'True'
        }
    },
    data(){
        return{
            activeTab:0
        }
    }
}
</script>
<style lang="scss">
@import "./../../../scss/main.scss";
</style>